const Form018SC = {
    stepName: {
        importantNotes: "重要提示",
        applicationInfo: "申请资料",
        confirmation: "确认",
    },
    label: {
        note: "注意",
        completedByEDB: "此栏由教育局填写",
    },
    formLabel: {
        refNo: "档案编号",
        refNo2: "(只供部门使用)",
        name: "申请者姓名",
        name2: "(必须与香港身份证所示者相同)：",
        nameEn: "(英文)",
        nameCn: "(中文)",
        address: "通讯地址 (请以英文填写)",
        tel: "联络电话：",
        contactTelephone: "电话号码(学校/办公室)",
        shoolOrOfficeOp: {
            school: "学校电话号码",
            office: "办公室电话号码",
        },
        homeOrMoblieOp: {
            home: "住宅电话号码",
            mobile: "手提电话号码",
        },
        contactTelephoneNo: "电话号码(住宅/手提)",
        fax: "传真号码",
        email: "电邮地址",
        cardLabel: "香港身份证／护照号码：",
        idCard: "香港身份证",
        passPort: "护照",
        idCardOrpassPortOP: {
            idCard: "香港身份证",
            passPort: "护照",
        },
        registeredOrpermittedOp: {
            registeredT: "检定教员",
            permittedT: "准用教员",
        },
        shoolOrOrganisationOp: {
            school: "学校",
            organisation: "机构",
        },
        teacher: "检定教员／准用教员编号：",
        registeredT: "检定教员编号",
        permittedT: "准用教员编号",
        applicant: "申请人任职的学校／机构名称及地址：",
        organisation: "机构",
        schoolTypeTitle: "学校类别(如适用)：",
        schoolType: {
            primary: "小学",
            secondary: "中学",
            special: "特殊学校",
        },
        schoolType2: {
            government: "官立",
            aided: "资助",
            dss: "直接资助计划",
            others: "其他(请加以说明)",
        },
        teachingExperience: "教学经验：",
        teachingExperienceOp: {
            5: "5年",
            "6–10": "6 – 10年",
            "11–15": "11 – 15年",
            "over 15": "超过15年",
        },
        currentPosition: "目前在学校／机构的职位：",
        analysis: "修毕专业发展需要分析：",
        yesOrNo: {
            yes: "是",
            no: "否",
        },
        certificate: "发出证书日期",
        completion: "修毕拟任校长课程：",
        submittedPortfolioBefore: "曾提交专业发展资料册：",
        attainedCFP: "曾取得认证：",
        declaration: "声明",
        termsConditions: "本人谨此声明，本申请书中所有资料均属确实无讹。",
        applicantSignature: "申请人签署",
        date: "日期",
        nil: "提交日期",
        attachmentTooltip: "请附上有关的证书/证明信件的副本。",
        attachment: "附件",
    },
    confirmation: {
        label1: "号码",
        label2: "申请人任职的",
        label3: "名称及地址",
        label4: "目前在",
        label5: "的职位",
        label6: "其他",
    },
    importantNotes: {
        note1: "申请者请准备以格式JPG,PNG或PDF的有关文件档案:",
        note2: "(所有文件的总大小不可超过10MB)",
        note3: "申请者需透过已启用数码签署功能的「智方便」帐户，以办理网上递交申报表。",
        iamSignCheck: "本人理解申请人需要拥有「智方便+」帐户才能处理申请。",
    },
    errorMsg: {
        ref: "档案编号",
        nameEn: "姓名(英文)",
        nameCn: "姓名(中文)",
        teacherNo: "教员编号",
        date: "请输入一个有效的发出证书日期",
    },
};
export default Form018SC;
